module.exports = __webpack_public_path__ + "img/back-arrow.4c53c6a9.svg";